import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";

export const SearchFilterContainer = styled.div`
  margin-bottom: 36px;
`;

export const SearchFilterRow = styled.div`
  display: grid;
  grid-template: "organization useremail menu start timezone submit" / 1fr 1fr 1fr minmax(
      350px,
      2.7fr
    ) minmax(200px, 1.5fr) auto;

  margin-bottom: 12px;
  column-gap: 8px;

  .organizationid {
    grid-area: organization;
  }
  .useremail {
    grid-area: useremail;
  }

  .menu {
    grid-area: menu;
  }

  .timezone {
    grid-area: timezone;
  }
  .start {
    grid-area: start;
  }

  .submit {
    grid-area: submit;
  }

  @media (max-width: 1380px) {
    grid-template:
      "organization useremail menu"
      "start timezone submit";
  }

  ${mediaQuery.isMobile} {
    grid-template:
      "organization useremail"
      "menu timezone"
      "start start"
      "submit submit";
  }
`;

export const Label = styled.p`
  padding: 12px 0 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.COLORS.TEXT};
`;

export const FilterItem = styled.div``;

export const FilterItemSearchBtn = styled(FilterItem)`
  display: flex;
  align-items: flex-end;

  ${mediaQuery.isMobile} {
    padding-top: 20px;
    > button {
      width: 100%;
      height: 40px;
    }
  }
`;
